import { http } from '@/utils/axios'

/**
 * @msg: 监考管理列表查询
 */
export function getExamsUsersWithTour(data) {
    return http({
        url: http.baseUrl('elExamsUsers/getExamsUsersWithTour'),
        method: 'post',
        params: http.params(data)
    })
}
/**
 * @msg: 开始视频巡考
 */
export function startTouring(data) {
    return http({
        url: http.baseUrl('elExamsUsers/startTouring'),
        method: 'get',
        params: http.params(data)
    })
}
/**
 * @msg: 开始发起警告(暂无数据操作)
 */
export function startWarning(data) {
    return http({
        url: http.baseUrl('elExamsUsers/startWarning'),
        method: 'get',
        params: http.params(data)
    })
}
/**
 * @msg: 停止发起警告
 */
export function stopWarning(data) {
    return http({
        url: http.baseUrl('elExamsUsers/stopWarning'),
        method: 'get',
        params: http.params(data)
    })
}
/**
 * @msg: 终止考生考试
 */
export function stopExamsUsers(data) {
    return http({
        url: http.baseUrl('elExamsUsers/stopExamsUsers'),
        method: 'get',
        params: http.params(data)
    })
}
/**
 * @msg: 获取文字信息
 */
export function getMessage(data) {
    return http({
        url: http.baseUrl('elExamsUsers/getMessage'),
        method: 'get',
        params: http.params(data)
    })
}
/**
 * @msg: 获取文字信息
 */
export function getMessage3(data) {
    return http({
        url: http.baseUrl3('elExamsUsers/getMessage'),
        method: 'get',
        params: http.params(data)
    })
}
/**
 * @msg: 发送文字信息
 */
export function sendMessage(data) {
    return http({
        url: http.baseUrl('elExamsUsers/sendMessage'),
        method: 'get',
        params: http.params(data)
    })
}
/**
 * @msg: 发送文字信息
 */
export function sendMessage3(data) {
    return http({
        url: http.baseUrl3('elExamsUsers/sendMessage'),
        method: 'get',
        params: http.params(data)
    })
}
/**
 * @msg: 获取考试用户的图片帧列表
 */
export function getPhotoFrameList(data) {
    return http({
        url: http.baseUrl('elExamsUsers/getPhotoFrameList'),
        method: 'get',
        params: http.params(data)
    })
}
/**
 * @msg: 截取画面
 */
export function screenShot(filedata, data) {
    let formData = new FormData();
    formData.append('file', filedata);
    return http({
        url: http.baseUrl('elExamsUsers/screenShotWithFile'),
        method: 'post',
        params: http.params(data),
        data: formData
    })
}
/**
 * @msg: 获取考试用户的截取画面
 */
export function getScreenShotList(data) {
    return http({
        url: http.baseUrl('elExamsUsers/getScreenShotList'),
        method: 'get',
        params: http.params(data)
    })
}
/**
 * @msg: 获取考试用户的考试过程性截图
 */
export function getScreenShotListById(data) {
    return http({
        url: http.baseUrl('elExamsUsers/getScreenShotListById'),
        method: 'get',
        params: http.params(data)
    })
}
/**
 * @msg: 获取考试用户的审核记录
 */
export function getAuditRecordList(data) {
    return http({
        url: http.baseUrl('elExamsUsers/getAuditRecordList'),
        method: 'get',
        params: http.params(data)
    })
}
/**
 * @msg: 考试详情记录 审核通过
 */
export function auditPass(data) {
    return http({
        url: http.baseUrl('elExamsUsers/auditPass'),
        method: 'get',
        params: http.params(data)
    })
}
/**
 * @msg: 考试详情记录 审核查重
 */
export function repeatThan(data) {
    return http({
        url: http.baseUrl('elExamsUsers/repeatThan'),
        method: 'get',
        params: http.params(data)
    })
}
/**
 * @msg: 考试详情记录 审核不通过
 */
export function auditFailed(data) {
    return http({
        url: http.baseUrl('elExamsUsers/auditFailed'),
        method: 'get',
        params: http.params(data)
    })
}
/**
 * @msg: 批量巡考
 */
export function getExamsUsersTourList(data) {
    return http({
        url: http.baseUrl('elExamsUsers/getExamsUsersTourList'),
        method: 'post',
        params: http.params(data)
    })
}
/**
 * @msg: 结束巡考(巡考通过)
 */
export function tourPass(data) {
    return http({
        url: http.baseUrl('elExamsUsers/tourPass'),
        method: 'get',
        params: http.params(data)
    })
}
/**
 * @msg: 结束巡考(巡考不通过)
 */
export function tourFailed(data) {
    return http({
        url: http.baseUrl('elExamsUsers/tourFailed'),
        method: 'get',
        params: http.params(data)
    })
}